<div class="loading-container">
    <mat-spinner [diameter]="50"></mat-spinner>
</div>